/* global.js - Shopify Dawn compatibility layer */

// Cart drawer stub (will be replaced by Shopify's cart functionality)
class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }
}

if (customElements.get('cart-drawer') === undefined) {
  customElements.define('cart-drawer', CartDrawer);
}

// Predictive search stub
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }
}

if (customElements.get('predictive-search') === undefined) {
  customElements.define('predictive-search', PredictiveSearch);
}
